// extracted by mini-css-extract-plugin
module.exports = {"button":"Error_button__23uWU"};